import { BreakPoint } from '@/hooks/useBreakPoint/consts';
import clsx from 'clsx';
import Button from '../Button/Button';
import { ButtonColor } from '../Button/consts';
import { ButtonProps } from '../Button/interfaces';
import { ClickableAction } from '../Clickable/consts';
import LegacyPicture from '../LegacyPicture/LegacyPicture';
import styles from './HeatPumpTextBlockWithBadge.module.scss';
import type { HeatPumpTextBlockWithBadgeProps } from './interfaces';

const HeatPumpTextBlockWithBadge = ({
  badgeAlign,
  badgeImage,
  mobileBadgePosition,
  description,
  headline,
  linkintern,
  linkLabel = 'Mehr erfahren',
}: HeatPumpTextBlockWithBadgeProps) => {
  const shouldShowButton = !!linkintern && !!linkLabel;
  const buttonProps: ButtonProps = {
    actionType: ClickableAction.Linkintern,
    color: ButtonColor.Secondary,
    linkintern: linkintern ?? '',
  };
  const isBottomBadge = mobileBadgePosition === 'bottom';

  const BadgeImage = (
    <LegacyPicture
      asset={badgeImage}
      className={styles.badgeImage}
      fitCover
      breakpointAspectRatioConfigs={[
        {
          breakpoint: BreakPoint.XSS,
          width: 240,
          aspectRatio: '1:1',
        },
        {
          breakpoint: BreakPoint.SM,
          width: 240,
          aspectRatio: '1:1',
        },
        {
          breakpoint: BreakPoint.MD,
          width: 240,
          aspectRatio: '1:1',
        },
        {
          breakpoint: BreakPoint.LG,
          width: 240,
          aspectRatio: '1:1',
        },
        {
          breakpoint: BreakPoint.XL,
          width: 240,
          aspectRatio: '1:1',
        },
      ]}
    />
  );

  return (
    <div className={styles.base}>
      <div
        className={clsx(styles.badgeMobile, {
          [styles.badgeMobileBottom]: isBottomBadge,
        })}
      >
        {BadgeImage}
      </div>
      <h2 className={styles.headline}>{headline}</h2>
      <div className={styles.descriptionWrapper}>
        <div className={styles.description}>
          <div
            className={clsx(styles.descriptionBadgeFloat, {
              [styles.descriptionBadgeFloatRight]: badgeAlign === 'right',
            })}
          >
            {BadgeImage}
          </div>
          <div className={styles.descriptionContent}>
            <p>{description}</p>

            {shouldShowButton && (
              <div className={styles.buttonWrapper}>
                <Button {...buttonProps} className={styles.buttonStatic}>
                  {linkLabel}
                </Button>
                <div className={styles.buttonAbsolute}>
                  <Button {...buttonProps}>{linkLabel}</Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeatPumpTextBlockWithBadge;
